import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

const InputStatus = ({ type, name, value, onChange, required, error }) => {
  const { t } = useTranslation();

  const statusOptions = [
    { id: "inProgress", name: t("CARD_LIST_CUSTOM_SERVICE.inProgress") },
    { id: "open", name: t("CARD_LIST_CUSTOM_SERVICE.open") },
    { id: "closed", name: t("CARD_LIST_CUSTOM_SERVICE.closed") },
    { id: "cancelled", name: t("CARD_LIST_CUSTOM_SERVICE.cancelled") },
  ];

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("STATUS")}</label>
      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <select name={name} value={value} onChange={(e) => onChange(e, name)}>
        <option value={""}> {t("SELECT")}</option>
        {statusOptions.map((option) => (
          <option key={option.name} value={option.id}>
            {" "}
            {option.name}{" "}
          </option>
        ))}
      </select>
    </div>
  );
};

export default InputStatus;
